import { Map, fromJS } from 'immutable';
import * as actions from '../utils/Constants'

export default (state = getInitialState(), action) => {
    switch (action.type) {

        case actions.GET_PROJECT + actions.FULFILLED:
            return fromJS(action.payload);

        case actions.SET_PROJECT_FIELD:
            return state.set(action.field, action.payload);
           
        case actions.NEW_PROJECT:
            return getInitialState();


        default:
            return state;
    }
}

const getInitialState = () => {
    return Map({
        isActive: true
    });
};